// The Aprimo header image is the article's visible primary image, so it takes
// priority over the SEO sharing image, which stays as the fallback.
export function buildArticleImage(
  content: any,
  fallbackImage?: { url: string, altText: string },
  pageUrl?: string,
): any {
  const header = content?.aprimoArticleHeaderImage
  const headerUrl = typeof header?.url === 'string' ? header.url.trim() : ''
  const fallbackUrl = typeof fallbackImage?.url === 'string' ? fallbackImage.url.trim() : ''
  const url = headerUrl || fallbackUrl

  if (!url) {
    return undefined
  }

  const caption = headerUrl
    ? (content?.headerImageAltText?.value || header?.altText || '')
    : (fallbackImage?.altText || '')

  return {
    '@type': 'ImageObject',
    ...(pageUrl ? { '@id': `${pageUrl}#primaryimage` } : {}),
    'url': url,
    ...(caption ? { caption } : {}),
    // Dimensions belong to the header image; the fallback arrives without any.
    ...(headerUrl && header?.width ? { width: header.width } : {}),
    ...(headerUrl && header?.height ? { height: header.height } : {}),
  }
}
